export function validate_cpf(value) {
	const NOT_ALLOWED_SYMBOLS = /[^0-9.-]/i
	if (typeof value !== 'string' || NOT_ALLOWED_SYMBOLS.test(value)) {
		return false
	}

	const cleanCPF = value.replaceAll(/[.-]/g, '')
	if (!/^([0-9]){11}$/.test(cleanCPF) || check_same(cleanCPF)) {
		return false
	}

	const checkDigits = cleanCPF.slice(9)
	return checkDigits === calculate_last_digits(cleanCPF.slice(0, 9))
}

export function check_same(string_) {
	for (let i = 1; i < string_.length; i++) {
		if (string_[i] !== string_[0]) return false
	}
	return true
}

export function calculate_last_digits(cpf) {
	const IMPORTANCE_ARRAY = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]
	let sumFirstCheckDigit = 0
	let sumSecondCheckDigit = 0

	for (let i = 0; i < 9; ++i) {
		sumFirstCheckDigit += Number(cpf[i]) * IMPORTANCE_ARRAY[i + 1]
		sumSecondCheckDigit += Number(cpf[i]) * IMPORTANCE_ARRAY[i]
	}

	const remainerFirstCheckDigit = sumFirstCheckDigit % 11
	const firstCheckDigit =
		remainerFirstCheckDigit < 2 ? 0 : 11 - remainerFirstCheckDigit

	sumSecondCheckDigit += firstCheckDigit * IMPORTANCE_ARRAY[9]
	const remainerSecondCheckDigit = sumSecondCheckDigit % 11
	const secondCheckDigit =
		remainerSecondCheckDigit % 11 < 2 ? 0 : 11 - (remainerSecondCheckDigit % 11)

	return `${firstCheckDigit}${secondCheckDigit}`
}

window.validate_cpf = validate_cpf